import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UserService } from '../../core/providers/user/user.service';

import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { pluck, takeUntil, tap } from 'rxjs/operators';

import { CommonService } from '../../core/providers/forms/common.service';
import { ActivatedRoute } from '@angular/router';
import { Numbers } from 'src/app/utils/constants';
import HomeUtilsComponent from './home-utils.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  /**
   * @description constructor
   * @params user$
   * @params fb
   * @params commons
   * @params activatedRoute
   */
  constructor(
    private user$: UserService,
    private fb: FormBuilder,
    private commons: CommonService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute = activatedRoute;
    this.activatedRoute.queryParams.subscribe((params: any) => {
    });
    this.user$ = user$;
    this.fb = fb;
    this.commons = commons;
    this.utils = new HomeUtilsComponent();
  }

  @Input() SUCCESS: boolean;

  @Output() CLOSE_COMP: EventEmitter<any> = new EventEmitter();
  @Output() DATA_EMIT: EventEmitter<any> = new EventEmitter();
  @Output() SHOW_THANKS_NO_TPV: EventEmitter<any> = new EventEmitter();
  @Output() brokerLogo: EventEmitter<any> = new EventEmitter();

  public utils: HomeUtilsComponent;
  formData: FormGroup;
  finish = new Subject();
  formActive = '1';
  setChosedForm = '';
  setNameForm = '';
  setSecureForm = '';
  setNameFormLayer = '';
  showThanks = false;

  /**
   * @description metodo de inicio
   */
  ngOnInit() {
    this.user$.test();
    this.formActive = (this.commons.setForm()).toString();
    if (this.SUCCESS !== undefined) {
      this.showThanks = true;
    }
    // TODO: Modificar los valores correspondientes a cada formulario
    switch (this.formActive) {
      case '1':
        this.initIndividualTravelAsistance();
        break;
      case '2':
        this.initSportTravelAsistance();
        break;
      case '3':
        this.initParticularTravelAsistance();
        break;
      case '4':
        this.initParticularLegalAsistance();
        break;
      case '5':
        this.initOwnerLegalAsistance();
        break;
      case '6':
          this.initStudentsIncomingTravelAsistance();
          break;
      default:
        this.initIndividualTravelAsistance();
        break;
    }
    this.formData.valueChanges.pipe(
      takeUntil(this.finish),
      pluck(this.setChosedForm),
      tap(e => {
        // console.log( 'FORM Value', e );
        // console.log( 'FORM Change', this.formData );
      })
    ).subscribe();
  }
  /**
   * @description Iniciar Asistencia en viaje
   */
  initIndividualTravelAsistance(): void {
    this.setChosedForm = 'individualTravelAsistance';
    this.setNameForm = 'Seguro de asistencia viajes ocio';
    this.setSecureForm = 'travel-leisure';
    this.setNameFormLayer = 'Ocio';
    this.formData = this.fb.group({
      insureSelected: this.fb.group({
        chosed: this.setChosedForm,
        name: this.setNameForm,
        layerName: this.setNameFormLayer
      }),
      individualTravelAsistance: this.fb.group({
        insuranceTypeList: [[]],  // prop de apoyo se rellena con un array de opciones
        numberOfInsuredList: [[]],  // prop de apoyo se rellena con un array de opciones
        yearsList: [[]],  // prop de apoyo se rellena con un array de opciones
        sportList: [[]],  // prop de apoyo se rellena con un array de opciones
        sectorList: [[]],  // prop de apoyo se rellena con un array de opciones
        idCorreduria: '', // prop de apoyo se rellena con el valor de id correduría
        logoCorreduria: '', // prop de apoyo se rellena con el valor de url logo correduría
        numberOfInsured: ['', { updateOn: 'change' }],
        guaranteeLimitOfMedicalExpenses: ['', { updateOn: 'change' }],
        insuredOlderThan70years: '',
        insuredsPlayRiskSports: '',
        petInsureds: '',
        allInsuredSameFamiliarUnit: [null, { updateOn: 'change' }],
        insuranceDuration: '', // Temporalidad paso 1
        countryOrigin: [[], { updateOn: 'change' }],
        countryDestiny: ['', { updateOn: 'change' }],
        countryOriginEnvironment: '',
        countryDestinyEnvironment: '',
        dateStart: ['', { updateOn: 'change' }],
        dateEnd: ['', { updateOn: 'change' }],
        insuranceTime: '', // Radio paso 1 Temporal, anual
        currentlyTraveling: null,
        codePromotional: '',
        hasCodeDerogation: null,
        hasPetsInsurance: null,
        derogationCodes: [[]],
        insuranceType: '', // Temporalidad paso 2
        insuredData: this.fb.group({
          typeOwner: 'Particular',
          particular: this.fb.group({
            name: ['', { updateOn: 'change' }]
          }),
          bussines: this.fb.group({
            companySector: ['', { updateOn: 'change' }],
            direction: ['', { updateOn: 'change' }]
          }),
          documentType: ['', { updateOn: 'change' }],
          documentNumber: ['', { updateOn: 'change' }],
          firstSurname: '',
          secondSurname: '',
          email: ['', { updateOn: 'change' }],
          prefix: ['', { updateOn: 'change' }],
          telephone: ['', { updateOn: 'change' }],
          direction: ['', { updateOn: 'change' }],
          postalCode: ['', { updateOn: 'change' }],
          municipality: ['', { updateOn: 'change' }],
          province: ['', { updateOn: 'change' }],
          provinceId: 0,
          country: ['', { updateOn: 'change' }],
          sendAdvertisingInternationalSOS: null
        }),
        emergencyContact: this.fb.group({
          name: ['', { updateOn: 'change' }],
          firstSurname: ['', { updateOn: 'change' }],
          secondSurname: ['', { updateOn: 'change' }],
          prefix: ['', { updateOn: 'change' }],
          telephone: ['', { updateOn: 'change' }],
          relationWithInsured: ['', { updateOn: 'change' }],
          acceptTerms: [, { updateOn: 'change' }],
          adequacyOfProduct: [false, { updateOn: 'change' }],
          treatmentOfData: null,
          // sendAdvertisingInternationalSOS: null,
          sendAdvertisingByThirdParties: null,
          sendAdvertisingEventsAndNews: true
        }),
        insuredListData: this.fb.array([
          this.fb.group({
            documentType: ['', { updateOn: 'change' }],
            documentNumber: ['', { updateOn: 'change' }],
            name: ['', { updateOn: 'change' }],
            firstSurname: ['', { updateOn: 'change' }],
            secondSurname: '',
            dateBorn: '',
            prima: 0
          })
        ]),
        guaranteeSelection: this.fb.group({
          deathAndDisability: '',
          tripCancellation: '',
          lostOrStolenLuggage: '',
          vacationRefund: ''
        }),
        guaranteeSelectionList: [[]],
        termsList: [[
          { Aceptacion: '0', Id_Tipo_Consentimiento: '1' },
          { Aceptacion: '0', Id_Tipo_Consentimiento: '9' },
          { Aceptacion: '0', Id_Tipo_Consentimiento: '15' },
          { Aceptacion: '0', Id_Tipo_Consentimiento: '16' }
        ]]
      })
    });
  }

  /**
   * @description iniciar viaje de deporte
   */
  initSportTravelAsistance(): void {
    this.setChosedForm = 'sportTravelAsistance';
    this.setNameForm = 'Seguro de asistencia viajes deporte';
    this.setSecureForm = 'travel-sport';
    this.setNameFormLayer = 'Deporte';
    this.formData = this.fb.group({
      insureSelected: this.fb.group({
        chosed: this.setChosedForm,
        name: this.setNameForm,
        layerName: this.setNameFormLayer
      }),
      sportTravelAsistance: this.fb.group({
        insuranceTypeList: [[]],  // prop de apoyo se rellena con un array de opciones
        numberOfInsuredList: [[]],  // prop de apoyo se rellena con un array de opciones
        yearsList: [[]],  // prop de apoyo se rellena con un array de opciones
        sportList: [[]],  // prop de apoyo se rellena con un array de opciones
        sectorList: [[]],  // prop de apoyo se rellena con un array de opciones
        idCorreduria: '',
        logoCorreduria: '', // prop de apoyo se rellena con el valor de url logo correduría
        numberOfInsured: ['', { updateOn: 'change' }],
        guaranteeLimitOfMedicalExpenses: ['', { updateOn: 'change' }],
        insuredOlderThan70years: '',
        insuredsPlayRiskSports: '',
        allInsuredSameFamiliarUnit: [null, { updateOn: 'change' }],
        insuranceDuration: '', // Temporalidad paso 1
        countryOrigin: [[], { updateOn: 'change' }],
        countryDestiny: [[], { updateOn: 'change' }],
        sports: [[], { updateOn: 'change' }],
        countryOriginEnvironment: '',
        countryDestinyEnvironment: '',
        dateStart: ['', { updateOn: 'change' }],
        dateEnd: ['', { updateOn: 'change' }],
        insuranceTime: '', // Radio paso 1 Temporal, anual
        currentlyTraveling: null,
        codePromotional: '',
        hasCodeDerogation: null,
        derogationCodes: [[]],
        insuranceType: '', // Temporalidad paso 2
        insuredData: this.fb.group({
          typeOwner: 'Particular',
          particular: this.fb.group({
            name: ['', { updateOn: 'change' }]
          }),
          bussines: this.fb.group({
            companySector: ['', { updateOn: 'change' }],
            direction: ['', { updateOn: 'change' }]
          }),
          documentType: ['', { updateOn: 'change' }],
          documentNumber: ['', { updateOn: 'change' }],
          firstSurname: '',
          secondSurname: '',
          email: ['', { updateOn: 'change' }],
          prefix: ['', { updateOn: 'change' }],
          telephone: ['', { updateOn: 'change' }],
          direction: ['', { updateOn: 'change' }],
          postalCode: ['', { updateOn: 'change' }],
          municipality: ['', { updateOn: 'change' }],
          province: ['', { updateOn: 'change' }],
          provinceId: 0,
          country: ['', { updateOn: 'change' }],
          sendAdvertisingInternationalSOS: null
        }),
        emergencyContact: this.fb.group({
          name: ['', { updateOn: 'change' }],
          firstSurname: ['', { updateOn: 'change' }],
          secondSurname: ['', { updateOn: 'change' }],
          prefix: ['', { updateOn: 'change' }],
          telephone: ['', { updateOn: 'change' }],
          relationWithInsured: ['', { updateOn: 'change' }],
          acceptTerms: [false, { updateOn: 'change' }],
          adequacyOfProduct: [false, { updateOn: 'change' }],
          treatmentOfData: null,
          // sendAdvertisingInternationalSOS: null,
          sendAdvertisingByThirdParties: null,
          sendAdvertisingEventsAndNews: true
        }),
        insuredListData: this.fb.array([
          this.fb.group({
            documentType: ['', { updateOn: 'change' }],
            documentNumber: ['', { updateOn: 'change' }],
            name: ['', { updateOn: 'change' }],
            firstSurname: ['', { updateOn: 'change' }],
            secondSurname: '',
            dateBorn: '',
            email: ['', { updateOn: 'change' }]
          })
        ]),
        guaranteeSelection: this.fb.group({
          deathAndDisability: '',
          tripCancellation: '',
          lostOrStolenLuggage: '',
          vacationRefund: ''
        }),
        guaranteeSelectionList: [[]],
        termsList: [[
          { Aceptacion: '0', Id_Tipo_Consentimiento: '1' },
          { Aceptacion: '0', Id_Tipo_Consentimiento: '9' },
          { Aceptacion: '0', Id_Tipo_Consentimiento: '15' },
          { Aceptacion: '0', Id_Tipo_Consentimiento: '16' }
        ]]
      })
    });
  }
  /**
   * @description iniciar asitente viaje particular
   */
  initParticularTravelAsistance(): void {
    this.setChosedForm = 'particularTravelAsistance';
    this.setNameForm = 'Seguro de asistencia viajes particular';
    this.setSecureForm = 'travel-particular';
    this.setNameFormLayer = 'Particular';
    this.formData = this.fb.group({
      insureSelected: this.fb.group({
        chosed: this.setChosedForm,
        name: this.setNameForm,
        layerName: this.setNameFormLayer
      }),
      particularTravelAsistance: this.utils.particularTravelAsistanceUtils(this.fb)
    });
  }
  /**
   * @description iniciar asistente legal
   */
  initParticularLegalAsistance(): void {
    this.setChosedForm = 'particularLegalAsistance';
    this.setNameForm = 'Seguro de asistencia jurídica particulares';
    this.setSecureForm = 'travel-legal-particular';
    this.setNameFormLayer = 'Legal_Particular';
    this.formData = this.fb.group({
      insureSelected: this.fb.group({
        chosed: this.setChosedForm,
        name: this.setNameForm,
        layerName: this.setNameFormLayer
      }),
      particularLegalAsistance: this.utils.particularLegalAsistanceUtils(this.fb)
    });
  }
  /**
   * @description iniciar asistente empresa
   */
  initOwnerLegalAsistance(): void {
    this.setChosedForm = 'ownerLegalAsistance';
    this.setNameForm = 'Seguro de asistencia jurídica arrendado';
    this.setSecureForm = 'travel-legal-owner';
    this.setNameFormLayer = 'Legal_Arrendador';
    this.formData = this.fb.group({
      insureSelected: this.fb.group({
        chosed: this.setChosedForm,
        name: this.setNameForm,
        layerName: this.setNameFormLayer
      }),
      ownerLegalAsistance: this.fb.group({
        idCorreduria: '', // prop de apoyo se rellena con el valor de id correduría
        logoCorreduria: '', // prop de apoyo se rellena con el valor de url logo correduría
        numberOfInsured: 1,
        dateStart: ['', { updateOn: 'change' }],
        dateEnd: ['', { updateOn: 'change' }],
        insuranceTime: '', // Radio paso 1 Temporal, anual
        monthlyRent: ['', { updateOn: 'change' }],
        codePromotional: '',
        countryOriginEnvironment: Numbers.number19001,
        countryDestinyEnvironment: Numbers.number19001,
        insuranceDuration: 'Anual', // Temporalidad paso 1
        insuranceType: '', // Temporalidad paso 1 - radios
        insuranceType0Aux: '', // Auxiliar para almacenar valores del radio 0
        insuranceType1Aux: '', // Auxiliar para almacenar valores del servicio local
        insuredData: this.fb.group({
          typeOwner: 'Particular',
          particular: this.fb.group({
            name: ['', { updateOn: 'change' }]
          }),
          bussines: this.fb.group({
            companySector: ['', { updateOn: 'change' }],
            direction: ['', { updateOn: 'change' }]
          }),
          documentType: ['', { updateOn: 'change' }],
          documentNumber: ['', { updateOn: 'change' }],
          firstSurname: '',
          secondSurname: '',
          email: ['', { updateOn: 'change' }],
          prefix: ['', { updateOn: 'change' }],
          telephone: ['', { updateOn: 'change' }],
          direction: ['', { updateOn: 'change' }],
          postalCode: ['', { updateOn: 'change' }],
          municipality: ['', { updateOn: 'change' }],
          province: ['', { updateOn: 'change' }],
          provinceId: 0,
          country: ['', { updateOn: 'change' }]
        }),
        insuredListData: this.fb.group({
          owner: this.fb.group({
            documentType: ['', { updateOn: 'change' }],
            documentNumber: ['', { updateOn: 'change' }],
            name: ['', { updateOn: 'change' }],
            firstSurname: '',
            secondSurname: '',
            email: ['', { updateOn: 'change' }]
          }),
          inmueble: this.fb.group({
            direction: ['', { updateOn: 'change' }],
            postalCode: ['', { updateOn: 'change' }],
            municipality: ['', { updateOn: 'change' }],
            province: ['', { updateOn: 'change' }],
            provinceId: 0
          }),
          tenant: this.fb.group({
            documentType: ['', { updateOn: 'change' }],
            documentNumber: ['', { updateOn: 'change' }],
            name: ['', { updateOn: 'change' }],
            firstSurname: '',
            secondSurname: ''
          })
        }),
        domiciliation: this.fb.group({
          iban: ['', { updateOn: 'change' }],
          swift: ['', { updateOn: 'change' }],

          acceptIban: [null, { updateOn: 'change' }],
          acceptTerms: [null, { updateOn: 'change' }],
          adequacyOfProduct: [false, { updateOn: 'change' }],
          treatmentOfData: null,
          sendAdvertisingInternationalSOS: null,
          sendAdvertisingByThirdParties: null,
          sendAdvertisingEventsAndNews: null
        }),
        guaranteeSelection: this.fb.group({
          deathAndDisability: '',
          tripCancellation: '',
          lostOrStolenLuggage: '',
          vacationRefund: ''
        }),
        guaranteeSelectionList: [[]],
        termsList: [[
          { Aceptacion: '0', Id_Tipo_Consentimiento: '1' },
          { Aceptacion: '0', Id_Tipo_Consentimiento: '9' },
          { Aceptacion: '0', Id_Tipo_Consentimiento: '15' },
          { Aceptacion: '0', Id_Tipo_Consentimiento: '16' }
        ]]
      })
    });
  }
  /**
   * @description iniciar asitente viaje de estudiantes incoming
   */
  initStudentsIncomingTravelAsistance(): void {
    this.setChosedForm = 'incomingStudentsTravelAsistance';
    this.setNameForm = 'Seguro de asistencia en viaje estudios';
    this.setSecureForm = 'travel-incoming-students';
    this.setNameFormLayer = 'Incoming_Students';
    this.formData = this.fb.group({
      insureSelected: this.fb.group({
        chosed: this.setChosedForm,
        name: this.setNameForm,
        layerName: this.setNameFormLayer
      }),
      incomingStudentsTravelAsistance: this.utils.fillIncomingStudentsTravelAsistance(this.fb)
    });
  }

  /**
   * @description recuperar formulario
   * @params path
   */
  getForm(path: string[]): AbstractControl {
    return this.formData.get(path);
  }
  /**
   * @description metodo que ejecutal al finalizar
   */
  ngOnDestroy() {
    this.finish.next(true);
  }
  /**
   * @description emisor de datos
   * @params ev
   */
  dataEmit2(ev: any): void {
    if (ev !== null && ev !== undefined) {
      let keyPress: any = null;
      if ( Object.keys(ev).length > 0 ) { keyPress = ev; }
      if (keyPress.close && keyPress !== null) {
        this.showThanks = false;
        this.CLOSE_COMP.emit(true);
        this.DATA_EMIT.emit({ close: true });
      }
    }
  }
  /**
   * @description paso agradecimiento
   * @params ev
   */
  stepThanks(ev: any): void {
    if (ev !== null && ev !== undefined) {
      let keyPress: any = null;
      if ( Object.keys(ev).length > 0 ) { keyPress = ev; }
      if (keyPress.thanks && keyPress !== null) {
        this.SHOW_THANKS_NO_TPV.emit({ thanks: true });
      }
    }
  }
  /**
   * @description enviar dato corredor - url logo
   * @params ev
   */
  brokerInfoLogo(ev: any): void {
    if (ev !== null && ev !== undefined) {
      let keyPress: any = null;
      if ( Object.keys(ev).length > 0 ) { keyPress = ev; }
      if (keyPress.showBrokerLogo && keyPress !== null) {
        this.brokerLogo.emit({ showBrokerLogo: true, urlBrokerLogo: keyPress.urlBrokerLogo });
      }
    }
  }
}
